export default __webpack_public_path__ + "static/media/Balthus's Woodsman Boots.e5f65a7b.jpg";